import { ComboBox, FormGroup, Label } from "@xola/ui-kit";
import clsx from "clsx";
import React from "react";
import { countries } from "./Countries";

interface CountrySelectProps {
    label?: string;
    inModal?: boolean;
    onChange: (option: { label: string; value: string }) => void;
    error?: string;
    className?: string;
}

export const CountrySelect = ({ label = "", error, inModal = true, onChange, className }: CountrySelectProps) => {
    const options = Object.entries(countries).map(([value, label]) => {
        return { label, value };
    });

    return (
        <FormGroup>
            <Label className={clsx(error ? "!text-danger" : null)}>
                {error ? `${label} ${error}` : label ?? "Country"}
            </Label>

            <ComboBox
                closeMenuOnSelect
                isError={!!error}
                options={options}
                placeholder="Country"
                defaultValue={{ label: "Country", value: "" }}
                styles={inModal ? { menuPortal: (base: any) => ({ ...base, zIndex: 30 }) } : undefined}
                menuPortalTarget={document.body}
                className={className}
                onChange={onChange}
            />
        </FormGroup>
    );
};
